import { DocumentsContextProvider } from '@/app/components/shared/EntityDocuments/DocumentsContext';
import { getContractDetailsQuery } from '@/app/hooks/queries/useContracts';
import { Main } from '@/app/ui/components/main';
import { Spinner } from '@/app/ui/components/spinner';
import { DocumentTypes } from '@/app/utils/constants';
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/contracts/$contractId/contract-management/$supplementId/_layout',
)({
  component: RouteComponent,
  loader: async (opts) => {
    const evaluation = await opts.context.queryClient.ensureQueryData(
      getContractDetailsQuery(opts.params.contractId),
    );
    if (!evaluation) throw notFound();
  },
  pendingComponent: () => (
    <Main className="relative">
      <Spinner kind="inset" />
    </Main>
  ),
});

function RouteComponent() {
  const { supplementId } = Route.useParams();

  return (
    <DocumentsContextProvider resourceId={supplementId} documentsType={DocumentTypes.SUPPLEMENT}>
      <Outlet />
    </DocumentsContextProvider>
  );
}
